import ApiService from "../../../../services/ApiService";

export const fetchUserMeetings = (userId: number, setMeetings: Function, setLoading: Function) => {
  setLoading(true);

  ApiService.get(`users/${userId}/meetings?fetch_types=true&order=asc`)
    .then((response) => {
      setMeetings(
        response.data.meetings.map((meeting: any) => ({
          ...meeting,
          dt_start: new Date(meeting.dt_start),
          dt_end: new Date(meeting.dt_end),
          is_future: new Date(meeting.dt_start).getTime() > Date.now(),
          type_name: meeting.type.name,
        }))
      );
    })
    .catch((error) => console.error("An error occurred while fetching user's meetings", error))
    .finally(() => setLoading(false));
};
